/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable prefer-destructuring */
import { region_country_dict } from './constantVariable';
// The 'getDefaultValue' function retrieves the default value from the antiscalant dictionary.
// If no default value is found, it returns an object with 'UNTREATED' set to 1.
// It then filters the keys of the default object where the value is 1 and returns the result.
export function getDefaultValue(dbTransactionDetails) {
  const value = dbTransactionDetails?.antiscalant_dict?.Default || { 'UNTREATED': 1 };
  const result = Object.keys(value).filter(key => value[key] === 1);
  return result;
};
export function getUserType() {
  const getUserEmail = sessionStorage.getItem('user_email');
  return getUserEmail?.split('@')[1] === 'veolia.com' ? 'internal' : 'external';
}
// The 'getRegionAccess' function checks the user's access to the region based on their email.
// It first retrieves the user's email and determines the user type based on the email domain.
// If the user is an internal user, it checks if the user is in the users dictionary.
// If the user is found, it checks the user's account type.
// If the user is an 'WF5 Administrator' or 'MemChem CoE', it returns true; otherwise, it returns false.
// If the user is not found in the dictionary, it returns false.
// If the user is an external user, it returns false.
export function getRegionAccess(dbTransactionDetails) {
  const getUserEmail = sessionStorage.getItem('user_email');
  if (getUserType() === 'internal') {
    if (Object.prototype.hasOwnProperty.call(dbTransactionDetails.users_dict, getUserEmail)) {
      const userValue = dbTransactionDetails.users_dict[getUserEmail];
      if (userValue.AccountType.includes('WF5 Administrator') || userValue.AccountType.includes('MemChem CoE')) {
        return true;
      }
      return false;
    }
    return false;
  }
};
export function getNFfeedAndCLROFrom(dbTransactionDetails, str = 'NF Module') {
  const getUserEmail = sessionStorage.getItem('user_email');
  // const getUserEmail = 'anitha-sravya.chanumolu@veolia.com';
  if (getUserType() === 'internal') {
    if (Object.prototype.hasOwnProperty.call(dbTransactionDetails.users_dict, getUserEmail)) {
      const userValue = dbTransactionDetails.users_dict[getUserEmail];
      if (userValue.AccountType.includes(str) || userValue.AccountType.includes('WF5 Administrator')) {
        return true;
      }
      return false;
    }
    return false;
  };
  return false;
}
/**
 * Determines if a user has access to Argo based on their user type and account details.
 * This function is used to control access permissions to Argo features/resources.
 * It performs different validation checks depending on whether the user is internal or external.
 * For external users, it validates their account type to ensure they are a Channel Partner.
 * @param {Object} dbTransactionDetails - The database transaction details object
 * @param {Object} dbTransactionDetails.users_dict - Dictionary mapping user emails to their account information
 * @returns {boolean} Returns true if the user has access to Argo, false otherwise
 */
export function getArgoFromAccess(dbTransactionDetails) {
  const getUserEmail = sessionStorage.getItem('user_email');
  if (getUserType() === 'internal') {
    return true;
  };
  if(getUserType() === 'external') {
    if (Object.prototype.hasOwnProperty.call(dbTransactionDetails.users_dict, getUserEmail)) {
      const userValue = dbTransactionDetails.users_dict[getUserEmail];
      if (userValue.AccountType.includes('Channel Patner')) {
        return true;
      }
      return false;
    }
    return false;
  }
  return false;
}
export function externalaccess(dbTransactionDetails) {
  const getUserEmail = sessionStorage.getItem('user_email');
  if (getUserType() === 'external') {
    if (Object.prototype.hasOwnProperty.call(dbTransactionDetails.users_dict, getUserEmail)) {
      const userValue = dbTransactionDetails.users_dict[getUserEmail];
      if (userValue.AccountType.includes('Channel Patner')) {
        return true;
      }
      return false;
    }
    return false;
  }
  return false;
};
export function getMassBalanceAccess(dbTransactionDetails) {
  const getUserEmail = sessionStorage.getItem('user_email');
  if (getUserType() === 'internal') {
    if (Object.prototype.hasOwnProperty.call(dbTransactionDetails.users_dict, getUserEmail)) {
      const userValue = dbTransactionDetails.users_dict[getUserEmail];
      if (userValue.AccountType.includes('WF5 Administrator')) {
        return true;
      }
      return false;
    }
    return false;
  };
  return false;
};
// 'Products' is a function that provides a list of products for a given region.
// It first attempts to find the region in the antiscalant dictionary.
// If the region is not found, it defaults to a predefined value.
// It then identifies keys in the region-specific object that have a value of 1.
// If there are any such keys, they are returned; if not, the default value is returned.
export function Products(dbTransactionDetails, region) {
  // Check if user is internal or has external access
  if ((getUserType() === 'internal') || (getUserType() === 'external' && externalaccess(dbTransactionDetails))) {
    localStorage.setItem('Active_DualequationCCPP', JSON.stringify(dbTransactionDetails?.antiscalant_dict?.Active_DualequationCCPP || {}));
    const filteredObj = dbTransactionDetails.antiscalant_dict[region];
    if (!filteredObj) {
      return getDefaultValue(dbTransactionDetails);
    }
    const result = Object.keys(filteredObj).filter(key => filteredObj[key] === 1);
    return result.length ? result : getDefaultValue(dbTransactionDetails);
  }
  return getDefaultValue(dbTransactionDetails);
};

// 'getRegion' is a function that returns an object with all available regions and the currently selected region.
// It extracts all regions from the region_country_dict and also includes the current region.
export function getRegion() {
  let region = sessionStorage.getItem('Region');
  if (!region && localStorage.getItem('unit_set_dict') && Object.keys(JSON.parse(localStorage.getItem('unit_set_dict'))).length > 0) {
    region = JSON.parse(localStorage.getItem('unit_set_dict')).Region;
  }
  // const region = Object.keys(region_country_dict).find(key => region_country_dict[key].includes(country));
  return {
    'regions': Object.keys(region_country_dict),
    'region': region,
  };
}
/**
 * Determines if a specific product (antiscalant) is available in the user's current region.
 * This function is used to:
 * - Validate product availability before displaying or allowing user access to specific products
 * - Enforce region-specific product restrictions based on the current session's region
 * - Check against a list of products available for the user's region from the database
 * @param {Object} dbTransactionDetails - Database transaction details containing user's antiscalant dictionary and region access information
 * @param {Object} dbTransactionDetails.antiscalant_dict - Dictionary of antiscalant products available to the user
 * @param {Object} argoDict - The product object to check availability for
 * @param {string} argoDict.antiscalant - The antiscalant product name/identifier to verify
 * @returns {boolean} True if the product is available in the current region, false otherwise.
 *                    Returns false if required data is missing or if user has region-wide access.
 */
export function isProductAvailableInRegion(dbTransactionDetails, argoDict) {
  const region = sessionStorage.getItem('Region');

  // Early returns for missing data
  if (!region || !dbTransactionDetails?.antiscalant_dict || !argoDict) return false;

  // Users with region-wide access can access all products
  if (getRegionAccess(dbTransactionDetails)) return false;

  // Check if product exists in available products for current region
  const regionProducts = Products(dbTransactionDetails, region) || [];
  return regionProducts.includes(argoDict.antiscalant);
}
